export default __webpack_public_path__ + "ch-sports.icon-3d6e9d635ea328e716e1c22e7b1f2c52.png";